<template>
  <div class="form-group-course-item">
    <div class="form-group-title">{{ groupColumn.label }}</div>
    <template v-for="(column, index) in groupColumn.column">
      <template v-if="column.type === 'title'">
        <formTitle :column="column" :key="index"></formTitle>
      </template>
      <template v-if="column.type === 'input'">
        <formInput :column="column" :key="index"></formInput>
      </template>
      <template v-if="column.type === 'radio'">
        <formRadio :column="column" :key="index"></formRadio>
      </template>
      <template v-if="column.type === 'checkbox'">
        <formCheckbox :column="column" :key="index"></formCheckbox>
      </template>
      <template v-if="column.type === 'textarea'">
        <formTextarea :column="column" :key="index"></formTextarea>
      </template>
      <template v-if="column.type === 'rate'">
        <formRate :column="column" :key="index"></formRate>
      </template>
    </template>
  </div>
</template>

<script>
import formTitle from './title.vue'
import formInput from './input.vue'
import formRadio from './radio.vue'
import formCheckbox from './checkbox.vue'
import formTextarea from './textarea.vue'
import formRate from './rate.vue'
export default {
  props: ['groupColumn'],
  components: {
    formTitle,
    formInput,
    formRadio,
    formCheckbox,
    formTextarea,
    formRate
  }
}
</script>

<style scoped lang="scss">
.form-group-title {
  margin: 10px 10px 0 10px;
  height: 40px;
  background: rgba(74, 134, 246, 0.16);
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
  color: #4465f3;
  font-size: 16px;
  font-weight: 700;
}
</style>
